export const baseUrl = 'https://student.healthyoung.life/school-web'
// export const baseUrl = 'http://47.92.232.4:8001/school-web'
// export const baseUrl = 'https://19xx.healthyoung.life/school-web'
// export const baseUrl = 'http://localhost:8080/school-web'
//export const baseUrl = 'http://test.healthyoung.life'
export const ERR_OK = 200
export const pageSize = 20
export const pageSizes = [20, 40, 60, 80, 100]
// 联盟
export const one = './static/images/logoTwo.png'
export const head = './static/images/headTwo.png'



// WEBPACK FOOTER //
// ./src/common/api/api.js